import * as graphql from 'generated/graphql';
import { dateTimeFieldPolicy } from 'modules/common/layer01/apolloClient/cache/typePolicies/fieldPolicies';
import { ITypeSpecificPolicy } from 'modules/common/layer01/apolloClient/cache/typePolicies/shared';



export const SubscriptionPlan: ITypeSpecificPolicy<graphql.SubscriptionPlan> = {
  fields: {
    currentPeriodEnd: dateTimeFieldPolicy(),
    currentPeriodStart: dateTimeFieldPolicy(),
    cancellationDate: dateTimeFieldPolicy()
  }
};
